import { GORef } from "./goref";
import { ActorObject } from "./actorobject";
import { SitCmd } from "./commands/sit";
import { SkillToObjCmd } from "./commands/skilltoobj";
import { SkillToSelfCmd } from "./commands/skilltoself";
import { debugValidateProps } from "../util/generic";
import { DEFAULT_ATTACK_DISTANCE } from "../constants";
import { ABILTYPE } from "../gamedata/chartypes";

export class CharObject extends ActorObject {
    name: any;
    level: any;
    job: any;
    gender: any;
    face: any;
    hairStyle: any;
    hairColor: any;
    hp: any;
    visParts: any;
    stats: any;
    ingStatus: any;
    isRunning: boolean;
    isSitting: boolean;
    isDriving: boolean;

    constructor(world: any) {
        super("char", world);
        this.name = undefined;
        this.level = undefined;
        this.job = undefined;
        this.gender = undefined;
        this.face = undefined;
        this.hairStyle = undefined;
        this.hairColor = undefined; // INFO: Unused
        this.hp = undefined;
        this.visParts = undefined;
        this.stats = undefined;
        this.ingStatus = undefined;
        this.isRunning = true;
        this.isSitting = false;
        this.isDriving = false;
        this.on("damage", this._onDamage.bind(this));
    }

    _toggleSit() {
        if (this.activeCmd instanceof SitCmd) {
            this._stop();
        } else {
            this._sit();
        }
    }

    _sit() {
        return this._setNextCmd(new SitCmd(this));
    }

    _skillToObj(objectRef: any, skillIdx: any) {
        if (!(objectRef instanceof GORef)) {
            console.warn("Reference passed to _attackObj was not a GORef.");
            return;
        }
        let skillData = GDM.getNow("skill_data");
        let skill = skillData.getData(skillIdx);
        return this._setNextCmd(new SkillToObjCmd(this, objectRef, skill));
    }

    _skillToSelf(skillIdx: any) {
        const skillData = GDM.getNow("skill_data");
        const skill = skillData.getData(skillIdx);
        return this._setNextCmd(new SkillToSelfCmd(this, skill));
    }

    _setMotion(motionIdx: any, loop: any = false) {
        // Timescale should not be hardcoded here...
        this.pawn.playMotion(motionIdx, 1.0, loop);
    }

    getAbilityValue(abilType: any) {
        switch (abilType) {
            case ABILTYPE.SEX:
                return this.gender;
            case ABILTYPE.CLASS:
                return this.job;
            case ABILTYPE.LEVEL:
                return this.level;
            case ABILTYPE.HAIRCOLOR:
                return this.hairColor;
            case ABILTYPE.HP:
                return this.hp;
        }
        console.warn("Attempted to retrieve unknown ability value:", abilType);
        return 0;
    }

    _onDamage(amount: any) {
        this.hp = Math.max(0, this.hp - amount);
    }

    debugValidate() {
        debugValidateProps(this, [
            ["name"],
            ["level", 0, 255],
            ["gender", 0, 1],
            // ["hairColor", 0],
            ["hp", 0, 999999],
            ["visParts"],
            ["stats"],
            ["pawn"],
        ]);
        if (this.stats) {
            this.stats.debugValidate();
        }
    }
}

global.DEFAULT_ATTACK_DISTANCE = DEFAULT_ATTACK_DISTANCE;

/**
 * @constructor
 */
